var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackUpCareCredits = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M4.5 18a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 4.5 18M5.25 14.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M0 2.25A2.25 2.25 0 0 1 2.25 0h19.5A2.25 2.25 0 0 1 24 2.25v19.5A2.25 2.25 0 0 1 21.75 24H2.25A2.25 2.25 0 0 1 0 21.75zm1.5 0a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75zm21 5.122V21.75a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75V7.372q.354.126.75.128h19.5q.396-.002.75-.128",
  clipRule: "evenodd"
})));
export default SvgBackUpCareCredits;